import { render, staticRenderFns } from "./GreyBarWithTitleAndValue.vue?vue&type=template&id=05c05303&scoped=true&"
import script from "./GreyBarWithTitleAndValue.vue?vue&type=script&lang=js&"
export * from "./GreyBarWithTitleAndValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c05303",
  null
  
)

export default component.exports